/**
 * @generated SignedSource<<10b3662a318ae67984f2afdd3553b370>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type apiKeysMutation$variables = {
  id: string;
};
export type apiKeysMutation$data = {
  readonly generateNewApiKey: {
    readonly clientID: number;
    readonly secretKey: string | null;
  };
};
export type apiKeysMutation = {
  response: apiKeysMutation$data;
  variables: apiKeysMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "secretKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiKeysMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ApiKey",
        "kind": "LinkedField",
        "name": "generateNewApiKey",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "apiKeysMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ApiKey",
        "kind": "LinkedField",
        "name": "generateNewApiKey",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72f1bb7cfe00d951736ff32f1642256d",
    "id": null,
    "metadata": {},
    "name": "apiKeysMutation",
    "operationKind": "mutation",
    "text": "mutation apiKeysMutation(\n  $id: ID!\n) {\n  generateNewApiKey(id: $id) {\n    clientID\n    secretKey\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb64407616872a6d37dede6655fd7272";

export default node;
